import { Navigate } from "react-router-dom";
import { useAuth, hasPerm, moduleVisible, isEleve } from "../context/AuthContext";

function AccessDenied() {
  return (
    <div className="min-h-screen flex items-center justify-center text-center p-6">
      <div>
        <p className="text-lg font-semibold mb-1">Accès refusé</p>
        <p className="text-muted-foreground">Vous n'avez pas accès à cette fonction.</p>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, adminOnly = false, requirePermission = null, requireAction = null, requireModule = null, eleveOnly = false }) {
  const { user, modules, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Chargement...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireModule && !moduleVisible(modules, requireModule)) return <AccessDenied />;
  if (adminOnly && !user.is_admin) return <Navigate to="/" replace />;
  if (eleveOnly && !isEleve(user)) return <Navigate to="/" replace />;
  if (requirePermission && !hasPerm(user, requirePermission, requireAction)) return <AccessDenied />;
  return children;
}
